import * as queries from "./queries"
import * as mutations from "./mutations"

export const user = { queries, mutations }
